export default __webpack_public_path__ + "static/media/093-curved-arrow.e13d9227.png";